/* RoyalDTF custom language selector */
(function () {
  'use strict';

  // ===========================================================================
  // Cross-subdomain cart carry (universal)
  //
  // Each language lives on its own subdomain and Shopify's cart/session
  // cookies are host-only, so every subdomain holds an independent cart.
  // To make ONE cart follow the visitor everywhere - selector clicks, Google
  // results, old email links, typed URLs - the theme maintains a "cart
  // beacon": a chunked cookie scoped to .royaldtf.com holding the most
  // recently active subdomain's cart (variant, quantity, line-item
  // properties, selling plan). It refreshes on page load, after any cart
  // mutation (fetch/XHR to /cart/add|update|change|clear), and when the tab
  // is hidden. When a page loads and the beacon belongs to ANOTHER host, the
  // missing lines are merged into this subdomain's cart via same-origin
  // /cart/add.js, then the beacon is rewritten from the merged result.
  //
  // The merge only adds what is missing (variant + full property set is the
  // line identity), so repeated crossings never duplicate quantities, never
  // wipe an existing cart, and UploadKit design uploads survive the trip.
  // Carts converge across subdomains instead of diverging. If cookies cannot
  // be written everything degrades to the old behavior (cart stays on the
  // subdomain where it was built). Visitors with no cart and no beacon pay
  // zero extra requests.
  // ===========================================================================

  var BEACON_COOKIE = 'rdtf_cc';       // chunked: rdtf_cc0, rdtf_cc1, ...
  var LEGACY_COOKIE = 'rdtf_ct';       // pre-2026-06-10 targeted hand-off
  var COOKIE_DOMAIN = '.royaldtf.com';
  var MAX_CHUNKS = 3;                  // ~9KB payload ceiling (header-size safety)
  var CHUNK_SIZE = 3000;
  var BEACON_TTL = 604800;             // 7 days (Shopify carts live 14)
  var LEGACY_TTL = 600;
  var LEGACY_HOSTS = { 'el.royaldtf.com': 1, 'cs.royaldtf.com': 1 }; // redirect-only hosts
  var syncRan = false;

  function b64uEncode(str) {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function b64uDecode(str) {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4) str += '=';
    return decodeURIComponent(escape(atob(str)));
  }

  function writeCookie(name, value, maxAge) {
    document.cookie = name + '=' + value +
      '; domain=' + COOKIE_DOMAIN + '; path=/; max-age=' + maxAge +
      '; secure; samesite=lax';
  }

  function readCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? m[1] : null;
  }

  function clearChunked(name) {
    for (var i = 0; i < MAX_CHUNKS; i++) writeCookie(name + i, '', 0);
  }

  function saveChunked(name, payload, ttl) {
    var raw = b64uEncode(JSON.stringify(payload));
    var chunks = [];
    for (var i = 0; i < raw.length; i += CHUNK_SIZE) chunks.push(raw.slice(i, i + CHUNK_SIZE));
    if (chunks.length > MAX_CHUNKS) return false;
    clearChunked(name);
    for (var j = 0; j < chunks.length; j++) {
      writeCookie(name + j, (j === 0 ? chunks.length + '.' : '') + chunks[j], ttl);
    }
    return readChunked(name) !== null; // false when cookies are blocked
  }

  function readChunked(name) {
    var first = readCookie(name + '0');
    if (!first) return null;
    var dot = first.indexOf('.');
    if (dot < 1) return null;
    var count = parseInt(first.slice(0, dot), 10);
    if (!count || count > MAX_CHUNKS) return null;
    var raw = first.slice(dot + 1);
    for (var i = 1; i < count; i++) {
      var c = readCookie(name + i);
      if (c === null) return null;
      raw += c;
    }
    try { return JSON.parse(b64uDecode(raw)); } catch (e) { return null; }
  }

  // Shopify treats variant + the full property set as the line identity;
  // mirror that so the delta merge matches real cart lines.
  function lineKey(variantId, properties) {
    var props = properties || {};
    var keys = Object.keys(props).sort();
    var parts = [];
    for (var i = 0; i < keys.length; i++) {
      parts.push(keys[i] + '\u0001' + String(props[keys[i]]));
    }
    return String(variantId) + '\u0000' + parts.join('\u0002');
  }

  function snapshotItems(cart) {
    return ((cart && cart.items) || []).map(function (i) {
      var s = { id: i.variant_id, q: i.quantity };
      if (i.properties && Object.keys(i.properties).length) s.p = i.properties;
      if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) {
        s.sp = i.selling_plan_allocation.selling_plan.id;
      }
      return s;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : { items: [] }; });
  }

  function addItems(items) {
    var post = function (body) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    };
    return post({ items: items }).then(function (r) {
      if (r.ok) return true;
      // Bulk add is all-or-nothing - one unavailable variant fails the lot.
      // Retry line by line so a single sold-out item can't block the rest.
      return items.reduce(function (chain, item) {
        return chain.then(function (any) {
          return post(item)
            .then(function (rr) { return rr.ok || any; })
            .catch(function () { return any; });
        });
      }, Promise.resolve(false));
    });
  }

  function refreshCartUi() {
    try {
      if (window.theme && typeof window.theme.refreshCart === 'function') {
        window.theme.refreshCart();
        return;
      }
    } catch (e) { /* fall through to manual update */ }
    fetchCart().then(function (cart) {
      var counts = document.querySelectorAll('.cart-link__count');
      for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;
      if (document.body) {
        document.body.classList.toggle('cart-has-items', cart.item_count > 0);
      }
    }).catch(function () {});
  }

  // Rewrite the beacon from this host's actual cart. Skips the write when the
  // beacon already reflects the same host + items. An empty cart only clears
  // a beacon THIS host owns - it must never destroy another subdomain's cart.
  function updateBeacon(cart) {
    var items = snapshotItems(cart);
    var existing = readChunked(BEACON_COOKIE);
    if (!items.length) {
      if (existing && existing.host === location.host) clearChunked(BEACON_COOKIE);
      return;
    }
    if (existing && existing.host === location.host &&
        JSON.stringify(existing.items) === JSON.stringify(items)) {
      return; // unchanged
    }
    var payload = { v: 3, host: location.host, ts: Date.now(), items: items };
    // Oversized carts (very long upload URLs): drop trailing lines until the
    // beacon fits rather than carrying nothing at all.
    var total = payload.items.length;
    while (payload.items.length && !saveChunked(BEACON_COOKIE, payload, BEACON_TTL)) {
      payload.items.pop();
    }
    if (payload.items.length && payload.items.length < total) {
      console.warn('[rdtf-cart] beacon truncated to ' + payload.items.length + ' of ' + total + ' lines');
    }
  }

  function importMissing(cart, items) {
    var have = {};
    ((cart && cart.items) || []).forEach(function (i) {
      var k = lineKey(i.variant_id, i.properties);
      have[k] = (have[k] || 0) + i.quantity;
    });
    var toAdd = [];
    (items || []).forEach(function (s) {
      var missing = s.q - (have[lineKey(s.id, s.p)] || 0);
      if (missing > 0) {
        var item = { id: s.id, quantity: missing };
        if (s.p) item.properties = s.p;
        if (s.sp) item.selling_plan = s.sp;
        toAdd.push(item);
      }
    });
    if (!toAdd.length) return Promise.resolve(false);
    return addItems(toAdd);
  }

  // Per-tab guard so a beacon line that can never be added here (e.g. sold
  // out) doesn't retrigger POSTs on every page view in this tab.
  function alreadyTried(tag) {
    try { return sessionStorage.getItem('rdtf_cc_tried') === tag; } catch (e) { return false; }
  }
  function markTried(tag) {
    try { sessionStorage.setItem('rdtf_cc_tried', tag); } catch (e) {}
  }

  // Runs on every page load. Zero-cost unless this visitor has a cart, a
  // beacon, or a legacy hand-off cookie.
  function syncCart() {
    if (syncRan) return;
    syncRan = true;
    if (LEGACY_HOSTS[location.host]) return; // host redirects away immediately

    var legacy = readChunked(LEGACY_COOKIE);
    if (legacy && (legacy.v !== 2 ||
        (legacy.dst && legacy.dst !== location.host) ||
        (legacy.ts && (Date.now() - legacy.ts) > LEGACY_TTL * 1000))) {
      legacy = null;
    }
    var beacon = readChunked(BEACON_COOKIE);
    var hasItemsHint = document.body && document.body.className.indexOf('cart-has-items') !== -1;
    if (!hasItemsHint && !beacon && !legacy) return;

    fetchCart().then(function (cart) {
      var foreign = null;
      if (legacy && legacy.items && legacy.items.length) {
        foreign = legacy.items; // in-flight switch from the previous version
      } else if (beacon && beacon.v === 3 && beacon.host !== location.host &&
                 beacon.items && beacon.items.length) {
        foreign = beacon.items;
      }

      var tag = foreign ? b64uEncode(JSON.stringify(foreign)).slice(0, 64) : null;
      var doImport = foreign && !alreadyTried(tag)
        ? importMissing(cart, foreign)
        : Promise.resolve(false);

      doImport.then(function (added) {
        if (tag) markTried(tag);
        if (legacy) clearChunked(LEGACY_COOKIE);
        var finalCart = added ? fetchCart() : Promise.resolve(cart);
        finalCart.then(function (fc) {
          if (added) refreshCartUi();
          updateBeacon(fc);
        });
      });
    }).catch(function () { /* retry on next page load */ });
  }

  // Keep the beacon fresh after cart mutations made by ANY script on the page
  // (theme AJAX, UploadKit, Gangify, quick-buy apps) - they all go through
  // fetch or XHR to the cart endpoints.
  function watchCartMutations() {
    if (LEGACY_HOSTS[location.host]) return;
    var re = /\/cart\/(add|update|change|clear)(\.js)?([?\/]|$)/;
    var timer = null;
    function bump() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetchCart().then(updateBeacon).catch(function () {});
      }, 600);
    }
    try {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = (typeof input === 'string') ? input : ((input && input.url) || '');
          if (re.test(url)) p.then(bump, function () {});
        } catch (e) {}
        return p;
      };
    } catch (e) {}
    try {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__rdtfCartCall = re.test(String(url || ''));
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__rdtfCartCall) this.addEventListener('loadend', bump);
        return origSend.apply(this, arguments);
      };
    } catch (e) {}
    // Last-chance refresh when the visitor leaves the tab (covers cart edits
    // the debounce hasn't flushed before they move to another subdomain).
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' &&
          document.body && document.body.className.indexOf('cart-has-items') !== -1) {
        fetchCart().then(updateBeacon).catch(function () {});
      }
    });
  }

  function init() {
    var root = document.querySelector('.royal-lang');
    if (!root) return;
    var trigger = root.querySelector('.royal-lang__trigger');
    var menu = root.querySelector('.royal-lang__menu');
    if (!trigger || !menu) return;

    var hoverCloseTimer = null;
    var isTouch =
      window.matchMedia && window.matchMedia('(hover: none)').matches;
    var cartDrawer = document.getElementById('CartDrawer');
    var slideNav = document.querySelector('.slide-nav__overflow--thumb');
    var slideNavButton = document.querySelector('.site-nav__thumb-button');

    function isCartDrawerOpen() {
      return document.documentElement.classList.contains('js-drawer-open') ||
        document.body.classList.contains('js-drawer-open') ||
        (cartDrawer && cartDrawer.classList.contains('drawer--is-open'));
    }

    function isSlideNavOpen() {
      return (slideNav && slideNav.classList.contains('js-menu--is-open')) ||
        (slideNavButton && slideNavButton.classList.contains('is-active'));
    }

    function syncSlideNavState() {
      var navOpen = isSlideNavOpen();
      document.body.classList.toggle('rdtf-slide-nav-open', navOpen);
      if (navOpen) close();
    }

    function open() {
      if (isCartDrawerOpen() || isSlideNavOpen()) {
        close();
        return;
      }
      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
      root.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      root.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose() {
      hoverCloseTimer = setTimeout(close, 180);
    }

    function closeIfCartDrawerOpen() {
      if (isCartDrawerOpen()) close();
    }

    function stopTriggerEvent(e) {
      if (!e) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    function toggleTrigger(e) {
      stopTriggerEvent(e);
      if (root.hasAttribute('data-open')) close();
      else open();
    }

    root.setAttribute('data-royal-lang-ready', 'true');
    window.royalLangReady = true;

    // Click trigger always toggles (works on desktop AND touch).
    trigger.addEventListener('click', toggleTrigger);

    // Some mobile apps/scripts can re-render the button after our first init.
    // Keep a delegated handler so taps still work even if the original node is replaced.
    document.addEventListener('click', function (e) {
      var clickedTrigger = e.target.closest && e.target.closest('.royal-lang__trigger');
      if (!clickedTrigger || !root.contains(clickedTrigger)) return;
      toggleTrigger(e);
    }, true);

    // Hover open on devices that can hover (desktops with mouse).
    if (!isTouch) {
      root.addEventListener('mouseenter', open);
      root.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('mouseenter', open);
    }

    // Click outside closes.
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    if (cartDrawer) {
      cartDrawer.addEventListener('click', close, true);
      cartDrawer.addEventListener('touchstart', close, true);
      cartDrawer.addEventListener('focusin', close, true);
    }

    if (slideNav) {
      slideNav.addEventListener('click', close, true);
      slideNav.addEventListener('touchstart', close, true);
      slideNav.addEventListener('focusin', close, true);
    }

    if (window.MutationObserver) {
      var drawerObserver = new MutationObserver(closeIfCartDrawerOpen);
      drawerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      if (cartDrawer) drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

      var slideNavObserver = new MutationObserver(syncSlideNavState);
      if (slideNav) slideNavObserver.observe(slideNav, { attributes: true, attributeFilter: ['class'] });
      if (slideNavButton) slideNavObserver.observe(slideNavButton, { attributes: true, attributeFilter: ['class'] });
    }

    if (window.theme && window.theme.jQuery) {
      window.theme.jQuery('body').on('drawerOpen.CartDrawer', close);
    }

    syncSlideNavState();

    // Escape closes; keyboard navigation through options.
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        open();
        var first = menu.querySelector('.royal-lang__option');
        if (first) first.focus();
      } else if (e.key === 'Escape') {
        close();
      }
    });

    menu.addEventListener('keydown', function (e) {
      var options = Array.prototype.slice.call(menu.querySelectorAll('.royal-lang__option'));
      var idx = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (options[idx + 1] || options[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (options[idx - 1] || options[options.length - 1]).focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        options[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        options[options.length - 1].focus();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        close();
        trigger.focus();
      }
    });

    // Resolve the localized URL of the current page for the destination
    // locale from the hreflang alternates in the head, so the user lands on
    // the TRANSLATED handle (the raw English handle can 404 on subdomains).
    // Exact locale first, then any regional variant of the language, then the
    // bare language code (handles pt vs pt-PT and similar).
    function resolveLocalizedUrl(locale, fallbackUrl) {
      locale = locale || '';
      var lang = locale.split('-')[0];
      var sel = 'link[rel="alternate"][hreflang="' + locale + '"]';
      if (lang && lang !== locale) {
        sel += ', link[rel="alternate"][hreflang="' + lang + '"]';
      }
      if (lang) {
        sel += ', link[rel="alternate"][hreflang^="' + lang + '-"]';
      }
      var matches;
      try { matches = document.querySelectorAll(sel); } catch (e) { matches = []; }
      if (matches.length > 0) {
        var last = matches[matches.length - 1];
        return last.getAttribute('href') || fallbackUrl;
      }
      return fallbackUrl;
    }

    menu.addEventListener('click', function (e) {
      var link = e.target.closest('.royal-lang__option');
      if (!link) return;
      if (link.classList.contains('is-current')) return;
      e.preventDefault();

      var rawDest = link.getAttribute('data-href');
      var loc = link.getAttribute('data-locale');
      if (!rawDest) return;
      var localizedDest = resolveLocalizedUrl(loc, rawDest);

      var u;
      try { u = new URL(localizedDest); } catch (err) {
        // Fall back to the homepage of the destination subdomain if URL parsing fails.
        try { u = new URL(rawDest); } catch (e2) { window.location.href = rawDest; return; }
        localizedDest = u.origin + '/';
      }

      // Same host (hreflang resolved to ourselves) - plain navigation.
      if (u.host === location.host) {
        window.location.href = localizedDest;
        return;
      }

      // Refresh the beacon from the latest cart state, then navigate; the
      // destination page imports whatever it is missing.
      fetchCart()
        .then(function (cart) { updateBeacon(cart); })
        .catch(function () {})
        .then(function () { window.location.href = localizedDest; });
    });
  }

  function onReady() {
    init();
    syncCart();
    watchCartMutations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
